/**
 This directive is used in tables to make the thead cells make them 
 sticky on scroll document
*/

var createFixedHeaderContainer = function(el) {
  return new Promise(resolve => {
    // we wait until th cells are available
    var getThs = function(el) {
      return new Promise(resolve => {
        (function waitForThs() {
          var ths = el.querySelectorAll(".md-table-head");
          if (ths.length) return resolve(ths);
          setTimeout(waitForThs, 500);
        })();
      });
    };

    getThs(el).then(function(ths) {
      var fixedHeadersContainer = document.createElement("div");
      fixedHeadersContainer.className = "fixed-headers hiddeable";
      ths.forEach(th => {
        var labelContainer = document.createElement("span");
        labelContainer.className = "md-table-head";
        labelContainer.style =
          "display: inline-block; width: " +
          th.getBoundingClientRect().width +
          "px";

        var label = document.createElement("span");
        label.className = "md-table-head-label";
        label.style = "width: " + th.getBoundingClientRect().width + "px;";
        th.querySelector('.md-table-head-label').childNodes.forEach(function(n) {
          if (n.nodeType === Node.TEXT_NODE) {
            label.append(n.nodeValue);
          }
        });
        labelContainer.appendChild(label);
        fixedHeadersContainer.append(labelContainer);
      });
      return resolve(fixedHeadersContainer);
    });
  });
};

var setInlineWidths = function(container) {
  setTimeout(() => {
    var inputCells = container
      .querySelector(".md-table-row:not(.computed-table-header)")
      .querySelectorAll(".md-table-cell-container");
    var headerCells = container.querySelectorAll(".md-table-head-container");

    inputCells.forEach(cell => {
      //eslint-disable-next-line
      cell.dataset.width = cell.parentElement.offsetWidth;
      cell.style = "width: " + cell.dataset.width + "px !important;";
    });

    var differentColspan =
      inputCells[0].parentElement.getAttribute("colspan") != 2;

    headerCells.forEach((cell, index) => {
      // sometime we have first cell with colspan or not. we check it to
      // clone the style of the proper cell

      //eslint-disable-next-line
      if (differentColspan) cell.style = "width: " + inputCells[index+1].dataset.width + "px !important;";
      //eslint-disable-next-line
      else cell.style = "width: " + inputCells[index].dataset.width + "px; !important";

      if (differentColspan && index == 0) {
        cell.style =
          "width: " +
          (parseInt(inputCells[0].dataset.width) +
            parseInt(inputCells[1].dataset.width)) +
          "px !important";
      }
    });
  }, 500);
};

var setInlineStyles = function(el, container) {
  var containerStyle =
    "top: " +
    document.querySelector(".main-panel .md-toolbar").getBoundingClientRect()
      .height +
    "px;";
  containerStyle += "width: " + el.getBoundingClientRect().width + "px;";
  container.style = containerStyle;
};

var bindEventsToContainer = function(el, container) {
  el.addEventListener("scroll", function(e) {
    container.scrollLeft = e.target.scrollLeft;
  });
  document.addEventListener("scroll", function(e) {
    // eslint-disable-next-line
    if (el.getBoundingClientRect().y > 0) container.classList.remove("fixed");
    else container.classList.add("fixed");
  });
};

export default {
  inserted: async function(el, binding, vnode) {
    // arg is used to speficy an already created element to work as fixed header row
    if (binding.arg) {
      var container = document.getElementsByClassName(binding.arg)[0];
      setInlineWidths(el);
      setInlineStyles(el, container);
      bindEventsToContainer(el, container);
    }
    // otherwise we will create it dinamically
    else {
      createFixedHeaderContainer(el).then(container => {
        el.prepend(container);
        setInlineStyles(el, container);
        bindEventsToContainer(el, container);
        document.addEventListener("scroll", function(e) {
          // eslint-disable-next-line
          container.style.display = el.getBoundingClientRect().y > 0 ? "none" : "flex";
        });
        document.dispatchEvent(new Event("scroll"));
      });
    }
  }
};
